<h1>
  <a routerLink="/explanation">Explanation</a>
  |
  <a routerLink="/characters/west-marches/*">West Marches</a>
  |
  <a routerLink="/characters/50-fathoms/*">50 Fathoms</a>
</h1>
<hr />
<router-outlet></router-outlet>
